
<div
  :class="classes(
    n(),
    n(`--${size}`),
  )
  "
  role="text"
  :aria-label="text"
>
  <slot />
  <div
    v-if="visible"
    :class="classes(
      n('content'),
      [!!$slots.default, n(`--float`)],
      [dot, n('--dot'), n(`--${shape}`)],
    )"
    :style="getOffsetStyle"
  >
    {{ text }}
  </div>
</div>
